import type { AppNotifEvent } from '@/features/application/app-events/types'

export const PLACEHOLDER_PRENOM = 'Ex : Jean' as const
export const PLACEHOLDER_NOM = 'Ex : Dupont' as const
export const PLACEHOLDER_NOM_NAIS = 'Ex : Durand' as const
export const PLACEHOLDER_DATE_NAIS = 'Ex : 01/01/1990' as const
export const PLACEHOLDER_EMPLOI_TUTEUR = 'Ex : Ingénieur' as const
export const PLACEHOLDER_DIPLOME_PREPARE = "Ex : Diplôme d'ingénieur" as const
export const PLACEHOLDER_ADR_VOIE = 'Ex : 10 impasse GRANET' as const
export const PLACEHOLDER_ADR_COMPLEMENT = 'Ex : Bâtiment B' as const
export const PLACEHOLDER_ADR_CP = 'Ex : 75001' as const
export const PLACEHOLDER_ADR_VILLE = 'Ex : Paris' as const
export const PLACEHOLDER_EMAIL = 'Ex: nom.prenom@email.fr' as const
export const PLACEHOLDER_TEL = 'Ex : 01 23 45 67 89' as const
export const PLACEHOLDER_DATE = 'Ex : 01/01/2024' as const
export const PLACEHOLDER_DUREE = 'Ex : 35h00'
export const PLACEHOLDER_MONTANT = 'Ex: 800,00' as const
export const PLACEHOLDER_MONTANT_HORAIRE = 'Ex: 15,00' as const
export const HINT_DATE = 'Format: JJ/MM/AAAA'
export const HINT_DUREE = 'Format: XX:XX ou XXhXX'
export const HINT_SIREN_SIRET_OF = "Siren ou Siret de l'organisme"
export const PLACE_HOLDER_SIREN = 'Ex : 123456789'
export const LABEL_NUMERO_VOIE = 'N° et voie'
export const LABEL_MONTANT_DEMANDE_HT = 'Montant demandé HT'
export const MSG_INFO_FSE =
  "Les demandes FSE sont traitées par ordre d'arrivée, sous réserve de complétude, et dans la limite des fonds octroyés par l'Etat. Au regard des dossiers déjà validés et en cours d'instruction par nos services, les dépôts sont clos pour le FSE 2025."
export const MSG_INFO_PIC =
  'Compte tenu du nombre de dossiers déjà validés ou actuellement en cours d’instruction, le dépôt des demandes PIC IAE 2025 est clos depuis le 23 novembre 2025.'

export const MSG_DRF_DEROGATION = undefined
//  'Nouvelle date limite de dépôt des contrats CIPI CDPI pour les DRF déposées entre le 15/11/2025 et le 02/02/2026 inclus : 26 mars 2026 (au lieu du 15/03/2026)'

export const MSG_INFO_ESPACE_FORMATION_PDC =
  "Pour les entreprises de moins de 50 salariés et IDCC 2002 et IDCC 1979 : Seules les formations dont les thématiques ne figurent pas sur Espace Formation peuvent être prises en charge au titre du plan de développement des compétences. Pensez à toujours vérifier si l'action de formation souhaitée existe sur "
export const LABEL_LINK_ESPACE_FORMATION = 'Espace formation.'
export const URL_ESPACE_FORMATION = 'https://espaceformation.akto.fr/branch-selection/'

export const MSG_WARNING_HABILITATION_CFA_RNCP =
  "Au regard des informations disponibles sur le site de France compétences, votre CFA n'a pas l'habilitation pour former à la certification visée (article R.6113-16 du code du travail)"

export const MSG_WARNING_HABILITATION_LIEU_FORMATION_RNCP =
  "Au regard des informations disponibles sur le site de France compétences, votre lieu de formation n'a pas l'habilitation pour former à la certification visée (article R.6113-16 du code du travail)"

export const NOTIF_SAISIE_SALARIE_MODIFIÉE: AppNotifEvent = {
  name: 'AppNotif',
  arg: {
    message: 'La modification du salarié a entrainé la réinitialisation du NIR',
    titre: 'Saisie modifiée',
    type: 'success',
  },
}
